import { utcToZonedTime } from 'date-fns-tz';
import { useCallback, useEffect, useState } from 'react';
import { timezone } from '../UpsertSchedule/utils';

export const useTimer = () => {
  const getLiveUTCDateTime = useCallback<() => Date>(
    () => utcToZonedTime(new Date(), timezone),
    []
  );
  const [liveUTCDateTime, setLiveUTCDateTime] = useState(getLiveUTCDateTime());
  useEffect(() => {
    const timer = setInterval(
      () => setLiveUTCDateTime(getLiveUTCDateTime()),
      1000
    );

    return () => {
      clearInterval(timer);
    };
  }, [getLiveUTCDateTime]);
  return [liveUTCDateTime];
};
